import { render, staticRenderFns } from "./DefectCard.vue?vue&type=template&id=2f5bac14&scoped=true"
import script from "./DefectCard.vue?vue&type=script&lang=js"
export * from "./DefectCard.vue?vue&type=script&lang=js"
import style0 from "./DefectCard.vue?vue&type=style&index=0&id=2f5bac14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bac14",
  null
  
)

export default component.exports